// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3U6nD","header":"MessagesList_header__3VzTC","chat":"MessagesList_chat__2UMiH"};